module.exports = __webpack_public_path__ + "media/bootstrap-icons/credit-card-2-front-3b12549a.svg";